import { httpClient } from "@coworker/http-client";
import {
  AllProgressByRound,
  ChartData,
  CountOnDivision,
  DeleteShoppingToolsBody,
  SettingsDefault,
  SettingsResponse,
  ShoppingToolsBody,
  ShoppingToolsTypeObject,
} from "./Types";

export const createShoppingTool = async (shoppingTool: ShoppingToolsBody) => {
  try {
    await httpClient.shoppingtools.post(`/shoppingtools/create-shoppingtools`, {
      body: shoppingTool,
    });
  } catch (error) {
    console.error(error);
  }
};

export const deleteShoppingTool = async (
  shoppingTool: DeleteShoppingToolsBody
) => {
  try {
    await httpClient.shoppingtools.delete(
      `/shoppingtools/delete-shoppingtools-on-tool`,
      { body: shoppingTool }
    );
  } catch (error) {
    console.error(error);
  }
};

export const fetchTodaysProgress = async (
  storeId: string,
  division: string,
  startOfDay: number,
  round: string
) => {
  try {
    const data = await httpClient.shoppingtools.post<{
      todaysProgress: number;
    }>(`/shoppingtools/fetch-todays-progress`, {
      body: { storeId, startOfDay, division, round },
    });

    return data.todaysProgress as number;
  } catch (error) {
    return console.error(error);
  }
};

export const fetchLatestShoppingTools = async (storeId: string) => {
  try {
    const data = await httpClient.shoppingtools.post<ShoppingToolsTypeObject>(
      `/shoppingtools/fetch-latest-shoppingtools-by-store-id`,
      { body: { storeId } }
    );

    return data;
  } catch (error) {
    return console.error(error);
  }
};

export const fetchDivisionsCountByRound = async (
  storeId: string,
  division: string,
  roundName: string,
  startOfDay: number
) => {
  try {
    const data = await httpClient.shoppingtools.post<{ count?: number }>(
      `/shoppingtools/fetch-divisions-count-by-round`,
      { body: { storeId, division, roundName, startOfDay } }
    );

    return data.count ?? 0;
  } catch (error) {
    console.error(error);
    return 0;
  }
};

export const fetchCountOnDivision = async (
  storeId: string,
  division: string,
  roundName: string,
  startOfDay: number
) => {
  try {
    const data = await httpClient.shoppingtools.post<CountOnDivision>(
      `/shoppingtools/fetch-shoppingtools-count-on-division`,
      { body: { storeId, division, roundName, startOfDay } }
    );

    return data;
  } catch (error) {
    return console.error(error);
  }
};

export const fetchAllProgressByRound = async (
  storeId: string,
  startOfDay: number
) => {
  try {
    const data = await httpClient.shoppingtools.post<AllProgressByRound>(
      `/shoppingtools/fetch-all-progress-by-round`,
      { body: { storeId, startOfDay } }
    );

    return data;
  } catch (error) {
    return console.error(error);
  }
};

export const fetchChartData = async (
  storeId: string,
  startDate: number,
  endDate: number
) => {
  try {
    const data = await httpClient.shoppingtools.post<ChartData[]>(
      `/shoppingtools/fetch-chart-data`,
      { body: { storeId, startDate, endDate } }
    );

    return data;
  } catch (error) {
    return console.error(error);
  }
};

export const fetchShoppingToolsSettings = async (storeId: string) => {
  try {
    const data = await httpClient.shoppingtools.post<
      SettingsResponse[] | SettingsDefault[]
    >(`/settings/fetch-settings-on-store-id`, {
      body: { store_id: storeId },
    });

    return data;
  } catch (error) {
    return console.error(error);
  }
};

export const createOrUpdateShoppingtoolsSettings = async (
  createOrUpdateSettings: SettingsDefault[] | SettingsResponse[]
) => {
  try {
    await httpClient.shoppingtools.post(`/settings/change-settings`, {
      body: createOrUpdateSettings,
    });
  } catch (error) {
    console.error(error);
  }
};
